import { Controller } from "@hotwired/stimulus"

// GrantDialog di pages/Grants.js: i controlli di save() prima dell'invio (toast d'errore e niente invio, con gli stessi
// testi) e le parti che dipendono dal tipo: la quota a fondo perduto dei bandi misti e i campi dell'ESL per i prestiti
// e i misti non in equity. I campi nascosti restano nel form, come i valori del form dell'originale.
export default class extends Controller {
  static targets = ["nome", "tipo", "quota", "misto", "esl"]

  connect() {
    this.aggiorna()
  }

  aggiorna() {
    const tipo = this.tipoTarget.value
    const quota = this.quotaTarget.value || "prestito"
    this.mistoTarget.hidden = tipo !== "mixed"
    this.eslTarget.hidden = !(tipo === "loan" || (tipo === "mixed" && quota !== "equity"))
  }

  controlla(event) {
    let errore = ""
    if (!this.nomeTarget.value.trim()) errore = "Inserisci il nome del bando"
    else if (this.senzaLuoghi()) errore = "Scegli almeno un luogo per l'ambito territoriale"
    if (!errore) return
    event.preventDefault()
    window.toast?.error(errore)
  }

  // Un ambito locale (regione, provincia, comune) senza nessun luogo scelto.
  senzaLuoghi() {
    const ambito = this.element.querySelector("input[name='grant[territorio][ambito]']")?.value
    const elenco = { regione: "regioni", provincia: "province", comune: "comuni" }[ambito]
    if (!elenco) return false
    const campi = this.element.querySelectorAll(`input[name='grant[territorio][${elenco}][]']`)
    return ![...campi].some((c) => !c.disabled && c.value)
  }
}
